export default {
  "content": "<title>Icons/Down Arrow</title><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DFF5EF\" cx=\"24\" cy=\"24\" r=\"24\"/><path d=\"M24 37a1 1 0 01-1-1V12a1 1 0 012 0v24a1 1 0 01-1 1\" fill=\"#5D2193\"/><path d=\"M24 37.414l-9.707-9.707a.999.999 0 111.414-1.413L24 34.587l8.293-8.294a.999.999 0 111.414 1.415L24 37.413z\" fill=\"#5D2193\"/></g>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};